import { createSlice } from '@reduxjs/toolkit';

export const navigation = createSlice({
  name: 'NAVIGATION',
  initialState: {}, // state comes from preloadedState in the store and overwrites

  reducers: {
    setIsFinalPageBeforeSubmission(state, action) {
      const { isFinalPageBeforeSubmission } = action.payload;
      return {
        ...state,
        isFinalPageBeforeSubmission,
      };
    },
    setIsFirstVisiblePostSubmissionPage(state, action) {
      const { isFirstVisiblePostSubmissionPage } = action.payload;
      return {
        ...state,
        isFirstVisiblePostSubmissionPage,
      };
    },
    pageChange(state, action) {
      const { currentPage, slideDirection } = action.payload;
      return {
        ...state,
        currentPage,
        slideDirection,
      };
    },
    setIsLoading(state, action) {
      const { isLoading } = action.payload;
      return {
        ...state,
        isLoading,
      };
    },
    setProgressBarStages(state, action) {
      const { progressBarStages } = action.payload;
      return {
        ...state,
        progressBarStages,
      };
    },
  },
});

const { actions, reducer } = navigation;

export const {
  pageChange,
  setIsFinalPageBeforeSubmission,
  setIsFirstVisiblePostSubmissionPage,
  setIsLoading,
  setProgressBarStages,
} = actions;

export default reducer;
